<!--
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
-->
<template>
  <Modal
    :visible="visible"
    centered
    :width="450"
    :class="$style.switchAccountDialog"
    @cancel="handleClose"
  >
    <template #title>
      <div :class="$style['switch-title']">
        <i :class="$style['switch-title-icon']"></i>
        <div :class="$style['switch-title-text']">
          {{ $t('2570e0f00b') }}
        </div>
      </div>
    </template>
    <div :class="$style['switch-content']">
      「{{ companyName }}」{{ $t('40d16a007e') }}
      <img :class="$style['switch-content-logo']" :src="userLogo" />
      <span :class="$style['switch-content-name']">{{ userName }}</span>
      {{ $t('81376b92e4') }}
    </div>
    <template #footer>
      <div :class="$style['switch-footer']">
        <Button
          :class="$style['switch-footer-btn']"
          type="primary"
          @click="handleClick"
        >
          {{ $t('ba679ba739', ['']) }}
        </Button>
        <div :class="$style['switch-footer-time']">
          {{ $t('c05f64c6c6', [`${times}s`]) }}
        </div>
      </div>
    </template>
  </Modal>
</template>
<script>
import { Account } from '@store/modules/user/constants'
import {
  CLOSEDIALOG,
  VISABEL,
  DIALOGDATA,
} from '@store/modules/switchAccount/constants'
import { Modal, Button } from 'ant-design-vue'
import { ref, computed, getCurrentInstance, watch } from 'vue'
import useStore from '@hooks/useStore'
import { useSwitchAccount } from '../hooks/useSwitchAccount'
import useReport from '../hooks/useReport'
export default {
  components: {
    Modal,
    Button,
  },
  setup() {
    let timer = null
    const vm = getCurrentInstance()
    const { switchAccount } = useSwitchAccount()
    const { report } = useReport()
    const times = ref(5)
    const store = useStore(vm)
    const visible = computed(() => store.state?.switchAccount[VISABEL])
    const companyName = computed(
      () => store.state?.switchAccount[DIALOGDATA].companyName
    )
    const openUrl = computed(
      () => store.state?.switchAccount[DIALOGDATA].openUrl
    )
    const companyId = computed(
      () => store.state?.switchAccount[DIALOGDATA].companyId
    )
    const account = computed(() => store.state?.user[Account]) // 用户信息
    const userName = computed(() => account.value?.nickname)
    const userLogo = computed(() => account.value?.pic)
    const initTimer = () => {
      timer = setInterval(() => {
        times.value--
        if (times.value === 0) {
          handleSwitchAccount()
        }
      }, 1000)
    }
    const handleSwitchAccount = () => {
      clearInterval(timer)
      timer = null
      times.value = 5
      switchAccount(openUrl, companyId)
      vm.proxy.$store.commit(CLOSEDIALOG)
    }
    const handleClick = () => {
      report({
        operation: 'click',
        company_id: companyId.value,
      })
      handleSwitchAccount()
    }
    const handleClose = () => {
      report({
        operation: 'close',
        company_id: companyId.value,
      })
      vm.proxy.$store.commit(CLOSEDIALOG)
    }
    watch(visible, val => {
      if (!val) return
      report({
        operation: 'show',
        company_id: companyId.value,
      })
      initTimer()
    })
    return {
      visible,
      userName,
      userLogo,
      times,
      companyName,
      handleClick,
      handleClose,
    }
  },
}
</script>
<style lang="scss" module>
.switchAccountDialog {
  width: 450px;
  :global {
    .ant-modal-header {
      padding: 24px 30px !important;
    }
    .ant-modal-body {
      padding: 30px !important;
    }
  }
  .switch-title {
    display: flex;
    align-items: center;
    .switch-title-icon {
      width: 30px;
      height: 30px;
      margin-right: 12px;
      background-image: url('../../../assets/Register/warn-blue.png');
      background-size: 100%;
      background-repeat: no-repeat;
    }
    .switch-title-text {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 20px;
      color: #3c414b;
      text-align: left;
      line-height: 30px;
    }
  }
  .switch-content {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #3c414b;
    line-height: 22px;
    .switch-content-logo {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      overflow: hidden;
      margin: 0 5px 0 10px;
    }
    .switch-content-name {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #949aae;
      letter-spacing: 0;
      line-height: 22px;
    }
  }
  .switch-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    .switch-footer-time {
      margin-top: 10px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #949aae;
      letter-spacing: 0;
      text-align: center;
      line-height: 18px;
    }
  }
}
</style>
